import ApiEnvironment from '../constants/ApiEnvironment';

const Environment = {
  getEnvironment: () => {
    // Sunucu tarafında çalışıyorsa
    if (typeof window === 'undefined') {
      return process.env.NODE_ENV === 'development'
        ? ApiEnvironment.Type.local
        : ApiEnvironment.Type.Release;
    }

    if (window.location.host.includes('localhost') || window.location.host.includes('127.0.0.1')) {
      return ApiEnvironment.Type.local;
    }
    if (window.location.host.includes('test')) {
      return ApiEnvironment.Type.test;
    }
    if (window.location.host.includes('ngrok')) {
      return ApiEnvironment.Type.local;
    }
    if (window.location.host.includes('10.34.60.')) {
      return ApiEnvironment.Type.localTest;
    }
    return ApiEnvironment.Type.Release;
  },
  isLocal: () => Environment.getEnvironment() === ApiEnvironment.Type.local,
  isRelease: () => Environment.getEnvironment() === ApiEnvironment.Type.Release,
};

export default Environment;
